import { useTranslation } from "react-i18next";
import { formatClock } from "../../../i18n/format";
import { cx } from "../cx";

/** "0:09 / 0:21" in mono. */
export function TimeReadout({
  positionMs,
  durationMs,
  className = "",
}: {
  positionMs: number;
  durationMs: number;
  className?: string;
}) {
  const { t } = useTranslation("components");
  return (
    <span
      data-component="TimeReadout"
      className={cx("whitespace-nowrap font-mono text-label text-ink-2 tabular-nums", className)}
    >
      {t("time.readout", { current: formatClock(positionMs), total: formatClock(durationMs) })}
    </span>
  );
}
